<div class="pill-btn-container">
  <button class="pill-btn" [class.active]="isActive || isActiveValue()" (click)="toggle()">
    <span class="pill-btn-hint" *ngIf="isActiveValue()">{{ btnHint }}</span>
    <span class="pill-btn-title" [class.hint-enabled]="isActiveValue() && btnHint" [class.active]="isActiveValue()">
      {{ btnTitle | pendingStatusToWaitingForApproval }}
    </span>
  </button>
  <i class="fa fa-times clear-filter-btn" (click)="onClear.emit(false)" *ngIf="isActiveValue()"></i>
</div>
